import React, { useState } from 'react'
import { Container, Row, Col, InputGroup, FormControl, Form, Button, Spinner } from 'react-bootstrap'
import ValidateAndGenerate from './ValidateAndGenerate'
import CreatableSelect from 'react-select/creatable'

const colleges = [
  'Nirmala Memorial Foundation Junior College of Commerce & Smt.Shanti Devi Shukla Junior College of Science Rani Sati Municipal School Bldg., Rani Sati Marg, Malad (East), Mumbai-400 097.',
  'Nirmala Memorial Foundation Junior College of Commerce & Science D.S. Rd (90 Feet Rd), Asha Nagar Thakur Complex, Kandivali (East), Mumbai-400 101',
  'Mithibai College of Arts, Chauhan Institute of Science & Amrutben Jivanlal College of Commerce And Economics Vile Parle (W) Mumbai-400 056.',
  'Matushri Kashiben Vrajlal Valia International Vidyalaya Sr. Secondary, Sheth M.K. High School Complex, Borivali (W), Mumbai-400 092.',
  'Prakash Vidyalaya and Junior College Shantilal Modi Road, Kandivali (W), Mumbai-400 067.',
  'Pace Junior Science College Dattatray Tower, Naik Wadi, Opp. Mc. Donald’s, Gokhale Road, Naupada, Thane (West)-400602.',
  'Pace Junior Science College Jaybhadra Villa, S.V. P. Road Mandpeshwar, Borivali (W), Mumbai-400 092',
  'Pace Junior Science College Jaybhadra Villa, S.V. P. Road Mandpeshwar Opp. MTNL Office, Near Borivali Railway Platform No.3, Mumbai-400 092',
  'Pace Junior Science College 401,406, 4th Floor, Shopper’s Point Building, S.V. Road, Andheri Station (W), Mumbai-400 058.',
  'Pace Junior Science College, Powai 3rd Floor Kutchi Bhavan, Near Jain Mandir, IIT Market, Powai, Kanjur Marg (W), Mumbai-400076.',
  'Pace Junior Science College, Plot No.446, Opp Shardashram Society, Near Central Bank of India Off. Bhavani Shankar Road, Dadar (W), Mumbai-400028.',
  'Agnel Technical College (Polytechnic) Fr. Agnel Ashram Bandra (W), Mumbai-400 050.',
  'Bhausaheb Vartak Polytechnic Vasai Road (W) 410 202 Dist-Palghar.',
  'Brihanmumbai Mahanagarpalikas Dixit Road, Junior College of Science Vile Parle (East), Mumbai-400 057. Government Polytechnic Mumbai49 Kherwadi Bandra (E), Mumbai-400 051.',
  'Gundecha Education Academy Thakur Village, Kandivali (E), Mumbai-400 101.',
  'Jai Bharat Junior College of Commerce & Science Mulund Colony Mulund (W), Mumbai-400 082',
  'Sind Educationists’ Association Jai Hind College Junior College Basantsing Institute of Science & J.T. Lalvani College of Commerce “A” Road, Churchgate Mumbai-400 020',
  'Jamnabai Narsee School JVPD Scheme Vile Parle (W), Mumbai-400 049',

  'Sardar Vallabhbhai Patel Junior college of Science & Commerce M.H.B. Colony, S.N. Dubey Road, Dahisar ( E), Mumbai-400 068.',
  'The Kandivli Education Society’s Shri Tikamdas Purshotam Bhatia College of Science Shantilal Modi Road, Kandivali (W), Mumbai-400 067.',
  'Thakur College of Science & Commerce Shyamnarayan Thakur Marg., Thakur Village, Kandivali East, Mumbai-400 101.',
  'K.J. Somaiya Junior College of Science & Commerce Vidyanagar, Vidyavihar, Ghatkopar, Mumbai-400 077.',
  'Kishinchand Chellaram College Vidyasagar Principal K.M. Kundnani Chowk, 124 Dinshaw Wachha Road, Churchgate Mumbai-400 020.',
  'S.S. & L.S. Patkar College of Arts & Science and V.P. Varde College of Commerce & Economics Goregaon (West), Mumbai-400 062.',
  'Alpha Jr. College of Science & Commerce Shahaji Raje Municipal School Building, Shahaji Raje Marg., Vileparle (E), Mumbai-57.',
  'Sathaye College (Junior College) Dixit Road, Vile Parle (East), Mumbai-400 057.',
  ' Vidyanidhi Jr. College of Science Vidyanidhi Marg., N.S. Rd. No-5. Juhu Mumbai-400 049.',
  'Prof. M.H. Kalra Junior College of Science I.C. Colony, New Link Road, Borivali (West).',
  'Shri Hari Educational Trust’s St. Rock’s Jr. College of Commerce And Science MMC School Bldg., Opp Eksar Talao, Eksar Road, Borivali (W), Mumbai-400 092.',
  "Bharitya Gramin Punnar-Rachana Sanstha's Mumbai Junior College of Arts, Commerce & Science J.K. Jadhav Knowledge Centre, Near BPT Hospital Wadala (E), Mumbai-400 037.",
  'Smt. Gokalibai P.P. High School & Acharya Ambalal V.Patel Jr. College Dadabhai Road, Vile Parle (West), Mumbai-400 056.',
  'Rais Hawa Foundation Trust Rims Internationals School and Junior College New Link Road, Near Yash Raj Studio, Andheri (West), Mumbai-400 053.',
]

const parsedReactOptions = colleges.map(value => {
  return {
    value: value,
    label: value,
  }
})
console.log('⚡️ ~ file: FormLC.js:48 ~ parsedReactOptions ~ parsedReactOptions:', parsedReactOptions)

const FormLC = props => {
  const [sapF, setSapF] = useState(false)
  const [fNameF, setFNameF] = useState(false)
  const [lNameF, setLNameF] = useState(false)
  const [fatherF, setFatherF] = useState(false)
  const [motherF, setMotherF] = useState(false)
  const [religionF, setReligionF] = useState(false)
  const [nationalityF, setNationalityF] = useState(false)
  const [POBF, setPOBF] = useState(false)
  const [DOBF, setDOBF] = useState(false)
  const [dateAdmissionF, setDateAdmissionF] = useState(false)
  const [prevCollegeF, setPrevCollegeF] = useState(false)
  const [uploadLoader, setUploadLoader] = useState(false)
  const [degreeF, setDegreeF] = useState(false)
  const [courseF, setCourseF] = useState(false)
  const [dateLeavingF, setDateLeavingF] = useState(false)
  const [cgpaF, setCgpaF] = useState(false)
  const validateFields = () => {
    if (props.retrievedSap === '') {
      props.setEmptyFields(true)
      setSapF(true)
    } else if (props.fName === '') {
      setSapF(false)
      props.setEmptyFields(true)
      setFNameF(true)
    } else if (props.lName === '') {
      setSapF(false)
      setFNameF(false)
      props.setEmptyFields(true)
      setLNameF(true)
    } else if (props.father === '') {
      setSapF(false)
      setFNameF(false)
      props.setEmptyFields(true)
      setLNameF(false)
      setFatherF(true)
    } else if (props.mother === '') {
      setSapF(false)
      setFNameF(false)
      props.setEmptyFields(true)
      setLNameF(false)
      setFatherF(false)
      setMotherF(true)
    } else if (props.religion === '') {
      setSapF(false)
      setFNameF(false)
      props.setEmptyFields(true)
      setLNameF(false)
      setFatherF(false)
      setMotherF(false)
      setReligionF(true)
    } else if (props.nationality === '') {
      setSapF(false)
      setFNameF(false)
      props.setEmptyFields(true)
      setLNameF(false)
      setFatherF(false)
      setMotherF(false)
      setReligionF(false)
      setNationalityF(true)
    } else if (props.POB === '') {
      setSapF(false)
      setFNameF(false)
      props.setEmptyFields(true)
      setLNameF(false)
      setFatherF(false)
      setMotherF(false)
      setReligionF(false)
      setNationalityF(false)
      setPOBF(true)
    } else if (props.DOB === '') {
      setSapF(false)
      setFNameF(false)
      props.setEmptyFields(true)
      setLNameF(false)
      setFatherF(false)
      setMotherF(false)
      setReligionF(false)
      setNationalityF(false)
      setPOBF(false)
      setDOBF(true)
    } else if (props.prevCollege === '') {
      setSapF(false)
      setFNameF(false)
      props.setEmptyFields(true)
      setLNameF(false)
      setFatherF(false)
      setMotherF(false)
      setReligionF(false)
      setNationalityF(false)
      setPOBF(false)
      setDOBF(false)
      setPrevCollegeF(true)
    } else if (props.dateAdmission === '') {
      setSapF(false)
      setFNameF(false)
      props.setEmptyFields(true)
      setLNameF(false)
      setFatherF(false)
      setMotherF(false)
      setReligionF(false)
      setNationalityF(false)
      setPOBF(false)
      setDOBF(false)
      setPrevCollegeF(false)
      setDateAdmissionF(true)
    } else if (props.degree === '') {
      setSapF(false)
      setFNameF(false)
      props.setEmptyFields(true)
      setLNameF(false)
      setFatherF(false)
      setMotherF(false)
      setReligionF(false)
      setNationalityF(false)
      setPOBF(false)
      setDOBF(false)
      setPrevCollegeF(false)
      setDateAdmissionF(false)
      setDegreeF(true)
    } else if (props.course === '') {
      setSapF(false)
      setFNameF(false)
      props.setEmptyFields(true)
      setLNameF(false)
      setFatherF(false)
      setMotherF(false)
      setReligionF(false)
      setNationalityF(false)
      setPOBF(false)
      setDOBF(false)
      setPrevCollegeF(false)
      setDateAdmissionF(false)
      setDegreeF(false)
      setCourseF(true)
    } else if (props.dateLeaving === '') {
      setSapF(false)
      setFNameF(false)
      props.setEmptyFields(true)
      setLNameF(false)
      setFatherF(false)
      setMotherF(false)
      setReligionF(false)
      setNationalityF(false)
      setPOBF(false)
      setDOBF(false)
      setPrevCollegeF(false)
      setDateAdmissionF(false)
      setDegreeF(false)
      setCourseF(false)
      setDateLeavingF(true)
    } else if (props.cgpa === '') {
      setSapF(false)
      setFNameF(false)
      props.setEmptyFields(true)
      setLNameF(false)
      setFatherF(false)
      setMotherF(false)
      setReligionF(false)
      setNationalityF(false)
      setPOBF(false)
      setDOBF(false)
      setPrevCollegeF(false)
      setDateAdmissionF(false)
      setDegreeF(false)
      setCourseF(false)
      setDateLeavingF(false)
      setCgpaF(true)
    } else {
      ValidateAndGenerate(
        props.retrievedSap,
        props.lName,
        props.fName,
        props.father,
        props.mother,
        props.religion,
        props.subcaste,
        props.nationality,
        props.POB,
        props.DOB,
        props.prevCollege,
        props.progress,
        props.conduct,
        props.dateAdmission,
        props.degree,
        props.course,
        props.dateLeaving,
        props.setLcAlreadyGenerated,
        setUploadLoader,
        props.setServerError,
        props.LCNumber,
        props.cgpa
      )
    }
  }
  return (
    <Container>
      <Form
        onSubmit={e => {
          e.preventDefault()
        }}
      >
        <Row style={{ marginTop: '1rem' }}>
          <Col>
            <strong>Details</strong>
          </Col>
        </Row>
        <Row>
          <Col sm={10} md={6}>
            <InputGroup className="mb-1 mt-1">
              <InputGroup.Text id="basic-addon1">SAP ID</InputGroup.Text>
              <FormControl
                placeholder=""
                aria-label="Username"
                aria-describedby="basic-addon1"
                required
                value={props.retrievedSap}
                onChange={e => {
                  props.setRetrievedSap(e.target.value)
                }}
              />
            </InputGroup>
            <Form.Text className="text-muted mb-2">
              {sapF ? <p style={{ color: 'red' }}>Please fill SAP ID.</p> : ''}
            </Form.Text>
          </Col>
        </Row>
        <Row>
          <Col sm={6} md={3}>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>
                <strong>Last Name</strong>
              </Form.Label>
              <Form.Control
                type="text"
                required
                value={props.lName}
                onChange={e => {
                  props.setLName(e.target.value)
                }}
              />
              <Form.Text className="text-muted mb-2">
                {lNameF ? <p style={{ color: 'red' }}>Please fill Last Name.</p> : ''}
              </Form.Text>
            </Form.Group>
          </Col>
          <Col sm={6} md={3}>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>
                <strong>Father's Name</strong>
              </Form.Label>
              <Form.Control
                type="text"
                required
                value={props.father}
                onChange={e => {
                  props.setFather(e.target.value)
                }}
              />
              <Form.Text className="text-muted mb-2">
                {fatherF ? <p style={{ color: 'red' }}>Please fill Father's Name.</p> : ''}
              </Form.Text>
            </Form.Group>
          </Col>
          <Col sm={6} md={3}>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>
                <strong>Mother's Name</strong>
              </Form.Label>
              <Form.Control
                type="text"
                required
                value={props.mother}
                onChange={e => {
                  props.setMother(e.target.value)
                }}
              />
              <Form.Text className="text-muted mb-2">
                {motherF ? <p style={{ color: 'red' }}>Please fill Mother's Name.</p> : ''}
              </Form.Text>
            </Form.Group>
          </Col>
          <Col sm={6} md={3}>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>
                <strong>First Name</strong>
              </Form.Label>
              <Form.Control
                type="text"
                required
                value={props.fName}
                onChange={e => {
                  props.setFName(e.target.value)
                }}
              />
              <Form.Text className="text-muted mb-2">
                {fNameF ? <p style={{ color: 'red' }}>Please fill First Name.</p> : ''}
              </Form.Text>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col sm={10} md={8}>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>
                <strong>Religion/Caste</strong>
              </Form.Label>
              <Form.Control
                type="text"
                required
                value={props.religion}
                onChange={e => {
                  props.setReligion(e.target.value)
                }}
              />
              <Form.Text className="text-muted mb-2">
                {religionF ? <p style={{ color: 'red' }}>Please fill Religion.</p> : ''}
              </Form.Text>
            </Form.Group>
          </Col>
          <Col sm={10} md={4}>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>
                <strong>Subcaste (Optional)</strong>
              </Form.Label>
              <Form.Control
                type="text"
                value={props.subcaste}
                onChange={e => {
                  props.setSubcaste(e.target.value)
                }}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col sm={6} md={4}>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>
                <strong>Nationality</strong>
              </Form.Label>
              <Form.Control
                type="text"
                required
                value={props.nationality}
                onChange={e => {
                  props.setNationality(e.target.value)
                }}
              />
              <Form.Text className="text-muted mb-2">
                {nationalityF ? <p style={{ color: 'red' }}>Please fill Nationality.</p> : ''}
              </Form.Text>
            </Form.Group>
          </Col>
          <Col sm={6} md={4}>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>
                <strong>Place of Birth</strong>
              </Form.Label>
              <Form.Control
                type="text"
                required
                value={props.POB}
                onChange={e => {
                  props.setPOB(e.target.value)
                }}
              />
              <Form.Text className="text-muted mb-2">
                {POBF ? <p style={{ color: 'red' }}>Please fill Place of Birth.</p> : ''}
              </Form.Text>
            </Form.Group>
          </Col>
          <Col sm={6} md={4}>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>
                <strong>Date of Birth</strong>
              </Form.Label>
              <Form.Control
                type="date"
                required
                value={props.DOB}
                onChange={e => {
                  props.setDOB(e.target.value)
                }}
              />
              <Form.Text className="text-muted mb-2">
                {DOBF ? <p style={{ color: 'red' }}>Please fill Date of Birth.</p> : ''}
              </Form.Text>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>
                <strong>Last School/College attended</strong>
              </Form.Label>
              <CreatableSelect
                isClearable
                options={parsedReactOptions}
                onChange={e => {
                  props.setPrevCollege(e.value)
                }}
              />
              <Form.Text className="text-muted mb-2">
                {prevCollegeF ? <p style={{ color: 'red' }}>Please Last School/College attended.</p> : ''}
              </Form.Text>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col sm={6} md={4}>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>
                <strong>Progress</strong>
              </Form.Label>
              <Form.Control type="text" disabled value={props.progress} />
            </Form.Group>
          </Col>
          <Col sm={6} md={4}>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>
                <strong>Conduct</strong>
              </Form.Label>
              <Form.Control type="text" disabled value={props.conduct} />
            </Form.Group>
          </Col>
          <Col sm={6} md={4}>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>
                <strong>Date of Admission</strong>
              </Form.Label>
              <Form.Control
                type="date"
                required
                value={props.dateAdmission}
                onChange={e => {
                  props.setDateAdmission(e.target.value)
                }}
              />
              <Form.Text className="text-muted mb-2">
                {dateAdmissionF ? <p style={{ color: 'red' }}>Please Fill Date of Admission.</p> : ''}
              </Form.Text>
            </Form.Group>
          </Col>
        </Row>
        <Row>
        <Col sm={6} md={4}>
            <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>
              <strong>Select Degree</strong>
            </Form.Label>
            <CreatableSelect
              isClearable
              options={[
                { value: 'B Tech', label: 'B Tech' },
                { value: 'BE', label: 'BE' },
              ]}
              onChange={(e) => {
                props.setDegree(e.value);
              }}
            />
            <Form.Text className="text-muted mb-2">
              {degreeF ? <p style={{ color: 'red' }}>Please select a degree.</p> : ''}
            </Form.Text>
            </Form.Group>
          </Col>
          <Col sm={6} md={4}>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>
                <strong>Course</strong>
              </Form.Label>
              <Form.Control
                type="text"
                required
                value={props.course}
                onChange={e => {
                  props.setCourse(e.target.value)
                }}
              />
              <Form.Text className="text-muted mb-2">
                {courseF ? <p style={{ color: 'red' }}>Please fill course.</p> : ''}
              </Form.Text>
            </Form.Group>
          </Col>
          <Col sm={6} md={4}>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>
                <strong>Date of Leaving</strong>
              </Form.Label>
              <Form.Control type="date" required 
              value={props.dateLeaving}
                onChange={e => {
                  props.setDateLeaving(e.target.value)
                }} />
              <Form.Text className="text-muted mb-2">
                {dateLeavingF ? <p style={{ color: 'red' }}>Please fill Date of leaving.</p> : ''}
              </Form.Text>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>
                <strong>Reason for leaving</strong>
              </Form.Label>
              <Form.Control
                type="text"
                required
                value={props.cgpa}
                onChange={e => {
                  props.setCgpa(e.target.value)
                }}
              />
              <Form.Text className="text-muted mb-2">
                {cgpaF ? <p style={{ color: 'red' }}>Please fill reason for leaving</p> : ''}
              </Form.Text>
            </Form.Group>
          </Col>
        </Row>
        {/* <Row>
          <Col sm={12}>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>
                <strong>Reason for Leaving</strong>
              </Form.Label>
              <Form.Control
                type="text"
                required
                value={props.reasonForLeaving}
                onChange={e => {
                  props.setReasonForLeaving(e.target.value)
                }}
              />
              <Form.Text className="text-muted mb-2">
                {reasonForLeavingF ? <p style={{ color: 'red' }}>Please fill Reason for leaving.</p> : ''}
              </Form.Text>
            </Form.Group>
          </Col>
        </Row> */}
        <Row>
          <Col sm={12}>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>
                <strong>Remarks</strong>
              </Form.Label>
              <Form.Control type="text" required value="NIL" disabled />
            </Form.Group>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col md={{ span: 6, offset: 3 }}>
            <Button className="mb-5" variant="primary" onClick={() => validateFields()}>
              Generate Leaving Certificate
            </Button>
          </Col>
          {uploadLoader ? <Spinner animation="border" /> : ''}
        </Row>
      </Form>
    </Container>
  )
}

export default FormLC
